export const ACTIVE_TOGGLES_QUERY_KEY = "activeToggles";

export function parseActiveTogglesParam(raw: string | null | undefined): string[] {
    if (!raw) {
        return [];
    }
    return raw
        .split(",")
        .map((value) => value.trim())
        .filter((value) => value.length > 0);
}
